import create from 'zustand';

interface LayoutStore {
  // Mobile layout states
  hideBottomBar: boolean;
  setHideBottomBar: (hide: boolean) => void;
  // AI Chat Sidebar state
  isAiChatSidebarOpen: boolean;
  setIsAiChatSidebarOpen: (open: boolean) => void;
}

const initialState = {
  hideBottomBar: false,
  isAiChatSidebarOpen: false,
};

const useLayoutStore = create<LayoutStore>((set) => ({
  ...initialState,
  setHideBottomBar: (hide) => set(() => ({ hideBottomBar: hide })),
  setIsAiChatSidebarOpen: (open) => set(() => ({ isAiChatSidebarOpen: open })),
}));

export default useLayoutStore;
